module.exports = __webpack_public_path__ + "static/media/x.54272518.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/x.svg
// module id = 365
// module chunks = 0